import { render, staticRenderFns } from "./URegisterComp.vue?vue&type=template&id=08e7a4a3&scoped=true&"
import script from "./URegisterComp.vue?vue&type=script&lang=ts&"
export * from "./URegisterComp.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterComp.vue?vue&type=style&index=0&id=08e7a4a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7a4a3",
  null
  
)

export default component.exports